import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { deleteParamsFromUrl, getUrlParam } from 'core-components/helpers/url'

/**
 * Removes the invite token from the registration URL.
 *
 * Registration access is decided by the signed-in HP ID, not by the token that
 * was mailed out with the invitation link. Older links still carry
 * `/token/<value>`, so it is dropped before anything reads the path — the login
 * redirect target is derived from the current pathname, and a stale token in it
 * would come back after sign-in.
 */
export const useDropInviteToken = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const token = getUrlParam('token')

  useEffect(() => {
    if (token) {
      navigate(deleteParamsFromUrl(['token']), { replace: true })
    }
  }, [navigate, pathname, token])

  return { hasToken: Boolean(token) }
}
